module.exports = __webpack_public_path__ + "static/media/machinery.5adda2c7.webp";